import { render, staticRenderFns } from "./model_list.vue?vue&type=template&id=c2ecae9a&scoped=true"
import script from "./model_list.vue?vue&type=script&lang=js"
export * from "./model_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ecae9a",
  null
  
)

export default component.exports